module.exports = __webpack_public_path__ + "img/1.d9c483f6.png";